<div class="form-row">
  <div class="tags-wrap">
    @if (showLabel()) {
      <rt-label no-margin layout-flex-1-0>
        {{ 'app.common.tags' | translate }}
      </rt-label>
    }
    <rt-attributes
      (query)="tagTypeaheadUpdate($event)"
      (loadMore)="loadMoreTags($event)"
      (delete)="deleteTag($event)"
      (save)="saveTag($event)"
      [translationsContext]="'tags'"
      [attributes]="tags.value"
      [suggestionsData]="$any(tagsTypeahead)"
      [canRemove]="true"
      [canPick]="true"
      [canCreate]="canManageAttributes"
      [isReadOnly]="isReadOnly()"
      [selectHeaderTemplate]="headerTemplate"
      [tagsHoverable]="false"
      [tagsClickable]="false"
    />

    <ng-template #headerTemplate>
      <rt-dropdown-header>
        {{ 'app.common.placeholders.search.tags.other' | translate }}
        @if (canManageAttributes) {
          <a
            href="https://recruitee.com"
            suffix
            [routerLink]="['/settings/tags']"
            [queryParams]="{ tab: 'offerTags' }"
            rt-icon-button
            iconName="settings"
            size="small"
            variant="plain"
          ></a>
        }
      </rt-dropdown-header>
    </ng-template>
  </div>
</div>
